import styled from 'styled-components';

import Button from 'components/shared/Button';
import ButtonGroup from 'components/shared/ButtonGroup';
import { colors } from 'styles/theme/colors';

type Props = {
  isEdit: boolean;
  criterion: string;
  description: string;
  onCriterionChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
  onSave: () => void;
  onCancel: () => void;
  isSaveDisabled: boolean;
};

export default function CriteriaForm({
  isEdit,
  criterion,
  description,
  onCriterionChange,
  onDescriptionChange,
  onSave,
  onCancel,
  isSaveDisabled,
}: Props) {
  return (
    <FormContainer>
      <FormHeaderGroup>
        <FormTitle>{isEdit ? 'Edit Criteria' : 'Add New Criteria'}</FormTitle>
        <FormSubtitle>
          {isEdit
            ? 'Edit the label and description for the admissions criteria'
            : 'Provide a label and description for the admissions criteria'}
        </FormSubtitle>
      </FormHeaderGroup>

      <FieldGroup>
        <Label>Criteria Label</Label>
        <StyledInput
          type='text'
          placeholder='Criteria Label'
          value={criterion}
          onChange={(e) => onCriterionChange(e.target.value)}
        />
      </FieldGroup>

      <FieldGroup>
        <Label>Provide a description/explanation for this criteria (optional)</Label>
        <Textarea
          placeholder='Add a criteria description here...'
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
        />
      </FieldGroup>

      <StyledButtonGroup>
        <Button variant='ghost' onClick={onCancel}>
          Cancel
        </Button>
        <Button onClick={onSave} disabled={isSaveDisabled}>
          {isEdit ? 'Update Criteria' : 'Save Criteria'}
        </Button>
      </StyledButtonGroup>
    </FormContainer>
  );
}

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const FormHeaderGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const FormTitle = styled.div`
  font-weight: 700;
  font-size: 14px;
`;

const FormSubtitle = styled.div`
  font-size: 12px;
  color: ${colors.black};
`;

const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Label = styled.label`
  font-size: 12px;
  color: ${colors.black75};
`;

const StyledInput = styled.input`
  box-sizing: border-box;
  padding: 8px;
  border: 1px solid ${colors.black25};
  border-radius: 3px;
  font-size: 14px;
  width: 100%;
  min-height: 40px;
  outline: none;

  &::placeholder {
    color: ${colors.black25};
  }

  &:focus {
    border-color: ${colors.primaryBlue};
  }
`;

const Textarea = styled.textarea`
  box-sizing: border-box;
  padding: 8px;
  border: 1px solid ${colors.black25};
  border-radius: 3px;
  font-size: 14px;
  font-family: inherit;
  width: 100%;
  min-height: 100px;
  resize: vertical;
  outline: none;

  &::placeholder {
    color: ${colors.black25};
  }

  &:focus {
    border-color: ${colors.primaryBlue};
  }
`;

const StyledButtonGroup = styled(ButtonGroup)`
  justify-content: flex-end;
`;
